import { useEffect } from "react";
import Nav from "@/components/Nav";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Constat from "@/components/Constat";
import Programme from "@/components/Programme";
import Pricing from "@/components/Pricing";
import Faq from "@/components/Faq";
import Footer from "@/components/Footer";

export default function Landing() {
  useEffect(() => {
    document.title = "MULTIPOLAR — Programme vidéo en cinq actes";
    const m = document.querySelector('meta[name="description"]');
    if (m)
      m.setAttribute(
        "content",
        "Le monde bascule, et les capitaux suivent. MULTIPOLAR vous montre les secteurs et les entreprises qui vont en profiter, et la méthode pour transformer l'actualité géopolitique en lecture d'investisseur."
      );
  }, []);

  return (
    <main data-testid="landing-page" className="relative">
      <Nav />
      <Hero />
      <Marquee />
      <Constat />
      <Programme />
      <Pricing />
      <Faq />
      <Footer />
    </main>
  );
}
